import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrDocumentGeneratedDate = createSelector(
  [selectQbrState],
  (state) => state.selectedDocument?.DocumentGeneratedDate
)
